import React, { useEffect, useState } from 'react';
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';

const IcTemplate = () => {
    const [userInfo, setUserInfo] = useState({});
    const [loader, setLoader] = useState(true);
    const [templateList, setTemplateList] = useState([])
    const [activeFilter, setActiveFilter] = useState('All');
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedLang, setSelectedLang] = useState('Select Language');

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        const fetchUserDetails = async () => {
            try {
                let user = JSON.parse(localStorage.getItem("user_details"));
                if (user) {
                    setUserInfo(user);
                } else {
                    const token = apiService.getAuthToken()
                    const result = await apiService.get('get-org-user-info', token);
                    localStorage.setItem('user_details', JSON.stringify(result.data))
                    if (result && result.status == "success") {
                        setUserInfo(result.data);
                    }
                }
            } catch (error) {
                setLoader(false);
                console.error("Error fetching user details:", error);
            } finally {
                setLoader(false);
            }
        };
        fetchUserDetails();
    }, []);

    let orgId = localStorage.getItem("ORGID");
    const shouldReloadDetails = !userInfo || Object.keys(userInfo).length == 0


    useEffect(() => {
        fetchTemplateList('All', 'ic');
    }, []);

    const fetchTemplateList = (category, role) => {
        setLoader(true)
        const token = apiService.getAuthToken();
        const url = category === 'All'
            ? `get-template-list?role=ic`
            : `get-template-list?category=${category}&role=ic`;

        apiService.get(url, token).then(
            (response) => {
                setTemplateList(response?.data);
                setLoader(false);
            },
            (error) => {
                setLoader(false);
                console.error("Error fetching data", error);
            }
        );
    };

    const handleFilterClick = (filter) => {
        setActiveFilter((prevFilter) => {
            if (prevFilter !== filter) {
                fetchTemplateList(filter);
            }
            return filter;
        });
    };

    // Get unique language options from the templates
    const languageOptions = ['Select Language', ...new Set(templateList?.map(t => t?.lang)?.filter(lang => lang != null))];

    // Filter templates by search term and selected language
    const filteredTemplates = templateList?.filter(template =>
        template?.title?.toLowerCase().includes(searchTerm?.toLowerCase()) &&
        (selectedLang === 'Select Language' || template?.lang === selectedLang)
    );

    return (

        <div className='page__main'>
            <div className="dashboard" style={{ minHeight: '100vh' }}>
                <div className="container-fuild mb-4">

                    <div className="d-flex flex-row justify-content-between align-items-center mb-4">
                        <div>
                            <h2 className="fw-semibold font-26 mb-2">Template Library</h2>
                            <p>Access ready-to-use templates for policies, reports, posters, and more—designed to help you stay compliant with ease.</p>
                        </div>


                        <div className="col-md-4 d-flex flex-row">

                            <select
                                className="template-library-select form-select w-50 me-2 py-1 position-relative"
                                value={selectedLang}
                                onChange={(e) => setSelectedLang(e.target.value)}
                            >
                                {languageOptions?.map(lang => (
                                    <option key={lang} value={lang}>
                                        {lang?.charAt(0)?.toUpperCase() + lang?.slice(1)}
                                    </option>
                                ))}
                            </select>

                            <div className="form-group w-50">
                                <input type="text" className="form-control py-2 font-18 mb-0 w-100" placeholder="Search" onChange={e => setSearchTerm(e.target.value)} style={{ Height: '50px !important' }} />
                            </div>
                        </div>
                    </div>

                    <div className="row m-0">
                        <ul className="nav nav-tabs mb-3 p-0">
                            <li className="nav-item">
                                <button
                                    className={`nav-link text-black ${activeFilter === 'All' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('All')}
                                >
                                    All
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className={`nav-link text-black ${activeFilter === 'filing' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('filing')}
                                >
                                    Filing
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className={`nav-link text-black ${activeFilter === 'inquiry' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('inquiry')}
                                >
                                    Inquiry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className={`nav-link text-black ${activeFilter === 'reports' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('reports')}
                                >
                                    Reports
                                </button>
                            </li>

                        </ul>

                    </div>

                    {loader ? <Loader /> : <>
                    {templateList?.length > 0 ? (
                        <div className="template-library row mb-4">
                            {filteredTemplates?.map(template => (
                                <div key={template?.id} className="col-md-3">
                                    <div className='card shadow-sm p-3 mb-4'>
                                        {template?.thumbnail && <img src={template?.thumbnail} alt="template-img" className='template-img' />}
                                        {!template?.thumbnail && <img src='images/template-image.png' alt="template-img" className='template-img' />}
                                        <h4 className='template-title font-18 my-4 fw-bold'>{template?.title}</h4>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>
                                                <span className='badge px-1 rounded-pill text-capitalize me-1' style={{ backgroundColor: 'lightgrey', color: '#191919c7', maxWidth: 'fit-content' }}>{template?.category?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</span>
                                                    {/* {template?.lang} */}
                                                    {template?.lang
                                                        ? (
                                                            <span
                                                                className='badge px-1 rounded-pill text-capitalize'
                                                                style={{ backgroundColor: 'lightgrey', color: '#191919c7', maxWidth: 'fit-content' }}
                                                            >
                                                                {template?.lang}
                                                            </span>
                                                        )
                                                        : template?.state
                                                            ? (
                                                                <span
                                                                    className='badge px-1 rounded-pill text-capitalize'
                                                                    style={{ backgroundColor: 'lightgrey', color: '#191919c7', maxWidth: 'fit-content' }}
                                                                >
                                                                    {template?.state}
                                                                </span>
                                                            )
                                                            : ""}
                                                </span>
                                            <span className='d-flex align-items-center'>
                                                {template?.upload_url?.slice(0, 2).map((file, index) => (
                                                    <a
                                                        key={index}
                                                        href={file?.url}
                                                        className='btn btn-primary btn-sm px-1 pt-0 pb-1 mx-1 d-flex align-items-center'
                                                        target='_blank'
                                                        rel='noopener noreferrer'
                                                        download={`${template?.title}-${file?.type}`}
                                                    >
                                                        {file?.type}
                                                        <img
                                                            src='/images/download.svg'
                                                            alt='download-icon'
                                                            width={10}
                                                            height={10}
                                                            className='ms-1'
                                                        />
                                                    </a>
                                                ))}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No templates found.</p>
                    )} </>}

                </div>
            </div>
        </div>
    )

};

export default IcTemplate;